import { createContext } from 'react';

export default createContext(0);
